var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _PROJECT_TYPES$CODING;

var _require = require('../constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES;

var ScratchEbotEmptyProject = 'ScratchEbotEmptyProject';
var ScratchComingSoonProject = 'ScratchComingSoonProject';
var ScratchConveyorParcelSorterBeginnerProject = 'ScratchConveyorParcelSorterBeginnerProject';
var ScratchConveyorParcelSorterCoreProject = 'ScratchConveyorParcelSorterCoreProject';
module.exports = {
  'Conveyor Sorter': _defineProperty({}, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING = {}, _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchConveyorParcelSorterBeginnerProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchConveyorParcelSorterCoreProject,
      projectVideoId: 'dv6etKxr'
    }
  }), _PROJECT_TYPES$CODING))
};